module.exports = __webpack_public_path__ + "img/action-refresh.441ce96c.svg";